var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconContribution(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 15,
    fill: "#FFEBDD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13784_4857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3335 16C29.6024 16 28.8714 16.1393 28.1751 17.3229C27.5832 18.3325 26.7129 18.3325 25.4248 18.3325C24.2759 18.3325 23.9626 19.2029 24.5544 20.0732C24.8329 20.5258 26.7129 23.6939 27.1655 24.425C27.5832 25.0168 29.3239 25.4346 30.6469 25.4346C30.7861 25.4346 30.7861 25.4346 30.9254 25.4346C32.2483 25.4346 34.2675 24.8427 34.1283 23.8331C33.989 21.9532 35.869 19.4814 36.1475 19.2029C36.5652 18.611 36.426 17.3229 35.2771 17.3229C34.9986 17.3229 34.6853 17.3229 34.4068 17.4622C34.1283 17.6014 33.6757 17.7407 33.2579 17.7407C32.9794 17.7407 32.6661 17.6014 32.5268 17.3229C31.6565 16.1393 30.9254 16 30.3335 16Z",
    fill: "#FCBF1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1657 24.4252C27.5835 25.1563 29.6375 25.4348 30.9256 25.4348C32.2486 25.4348 34.2678 24.843 34.1285 23.8334C33.9893 21.9534 35.8692 19.4816 36.1477 19.2031C35.5559 19.4816 35.1381 19.9342 34.5463 19.795C34.2678 20.0735 33.5367 21.8142 32.0745 21.8142C31.0649 21.8142 30.9256 20.352 30.1945 20.352C29.4635 20.352 29.3242 21.3616 28.7324 21.5008C27.4442 21.7794 26.3998 20.4912 25.7035 19.6209C25.425 19.6209 24.8332 19.1683 24.5547 20.2127C24.8332 20.4912 26.7132 23.6941 27.1657 24.4252Z",
    fill: "#FFDC53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8151 25.8516C32.8055 26.2693 31.6567 26.5827 30.9256 26.5827H30.6471C30.3685 26.5827 29.0456 26.5827 27.8968 26.1649C21.6303 28.0448 17 34.4158 17 38.9068C17 44.2681 23.545 44.9992 31.5174 44.9992C39.4898 44.9992 46.0348 44.2681 46.0348 38.9068C46 34.1373 40.7779 27.3137 33.8151 25.8516Z",
    fill: "#FCBF1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0217 39.1508C41.9965 41.6574 39.281 42.9803 37.8885 44.721L33.5367 45.0692L25.1814 44.721C25.3555 42.9223 26.9917 39.7775 32.1442 41.5878C38.5848 43.8507 37.5403 40.1658 37.5403 39.1508C37.5403 38.2805 36.67 34.625 38.2366 34.625C39.8032 34.625 39.8032 36.0176 41.0217 39.1508Z",
    fill: "#FCA81E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 18.5,
    r: 2.5,
    fill: "#120136"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 25.5,
    r: 1.5,
    fill: "#120136"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13784_4857"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white",
    transform: "translate(17 16)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContribution);
export default __webpack_public_path__ + "static/media/icon-contribution.b8bcf3925ea505a11a01c25b5023c545.svg";
export { ForwardRef as ReactComponent };